import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

const complaintApiUrl = '/Complaint';

const PostComplaintRequest = (data) => nzApiAxios.post(complaintApiUrl, data);

const API = {
  complaint: PostComplaintRequest
};

export default API;
